import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { CrearFuenteDto } from 'src/app/modelos/fuentesdtos/CrearFuenteDto';
import { HOST, TODAS_FUENTES, FUENTE_ID, FUENTE_EDITAR, FUENTES_POR_OPERACION, VERIFICAR_CONDIGO_ENTIDAD, FUENTE_ULTIMA_EDICION ,ACTIVAR_INACTIVAR_FUENTE } from '../../global';
import { HistorialFuentes } from 'src/app/modelos/fuentesdtos/HistorialFuente.interface';

@Injectable({
  providedIn: 'root'
})
export class AdminFuenteService {

  url: string= HOST;

constructor(
  private http: HttpClient
) { }

  todasLasFuentes():Observable<fuenteI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + TODAS_FUENTES;
    return this.http.get<fuenteI[]>(direccion,{'headers': header});
  }

  crearFuenteNueva(nuevaFuenteDto:CrearFuenteDto, urlservicio:string):Observable<any>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + urlservicio;
    return this.http.post<any>(direccion,nuevaFuenteDto, {'headers': header});
  }

  getFuenteById(id):Observable<fuenteI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + FUENTE_ID + id;
    return this.http.get<fuenteI>(direccion,{'headers': header});
  }

  guardarFuenteEditada(idUsu:any, fuente:fuenteI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + FUENTE_EDITAR + idUsu;
    const body = fuente;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }

  getFuentesByOpe(idOperacion):Observable<fuenteI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + FUENTES_POR_OPERACION + idOperacion;
    return this.http.get<fuenteI[]>(direccion,{'headers': header});
  }

  existeCodigoFuente(codSuper,codTipoE,codEnti,operacion):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + VERIFICAR_CONDIGO_ENTIDAD + codSuper + "/" + codTipoE + "/" + codEnti + "/" + operacion;
    return this.http.get<Boolean>(direccion,{'headers': header});
  }

  ultimaEdicionFuente(fuente:fuenteI):Observable<HistorialFuentes>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + FUENTE_ULTIMA_EDICION + fuente.id;
    return this.http.get<HistorialFuentes>(direccion,{'headers': header});
  }

  actualizarEstadoFuente(fuente:fuenteI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + ACTIVAR_INACTIVAR_FUENTE;
    const body = fuente;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }



}
